// import $ from "jquery";
// import "slick-carousel";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class sliderSwiper {
  constructor() {
    this.events();
    this.sliderInit();
    this.paginationClass = $('.slider-skillet-control .slider__pagination');
  }

  sliderInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    const sliders = document.querySelectorAll('.slider-skillet');
    sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 36,
        autoHeight: false,
        speed: 500,
        grabCursor: false,
        allowTouchMove: true,
        pagination: {
          el: '.slider-skillet-control .slider__pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.slider-skillet-navigation .slider__button-next',
          prevEl: '.slider-skillet-navigation .slider__button-prev',
        },
      });
    });
  }

  clickEvents() {}

  events() {
    this.clickEvents();
  }
}

export default sliderSwiper;
new sliderSwiper();
